module.exports = __webpack_public_path__ + "img/pic_shipeichanpin@2x.f1386813.png";